import { render, staticRenderFns } from "./UpdatePeriodForm.vue?vue&type=template&id=86140b56&scoped=true&"
import script from "./UpdatePeriodForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePeriodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86140b56",
  null
  
)

export default component.exports